'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT,
  app: {
    title: 'Caligram',
    description: 'Événements culturels, scientfiques et citoyens: conférences, événements littéraires, cinéma, musique, arts visuels, arts de la scène et autres.',
    domain: 'caligram.com',
    meta: {
      charSet: 'utf-8',
      property: {
        'og:site_name': 'Caligram',
        'og:image': 'http://api.caligram.com/logo.png',
        'og:locale': 'fr_CA',
        'og:title': 'Caligram',
        'og:description': 'Événements culturels, scientfiques et citoyens: conférences, événements littéraires, cinéma, musique, arts visuels, arts de la scène et autres.',
        'twitter:card': 'summary',
        'twitter:site': '@coopterritoires',
        'twitter:creator': '@coopterritoires',
        'twitter:title': 'Caligram',
        'twitter:description': 'Événements culturels, scientfiques et citoyens: conférences, événements littéraires, cinéma, musique, arts visuels, arts de la scène et autres.',
        'twitter:image': 'http://api.caligram.com/logo.png',
        'twitter:image:width': '232',
        'twitter:image:height': '58'
      }
    },
    googleAnalytics: {
      id: 'UA-81893922-1'
    },
    googleMaps: {
      apiKey: 'your-google-maps-api-key'
    },
    googleTagManager: {
      id: null
    },
    entities: {
      audiences: {
        initialData: null,
        inFilters: true,
        menu: [22, 24, 26, 23, 25, 21]
      },
      organizations: {
        inFilters: false
      },
      regions: {
        initialData: [{ id: 3, label: 'au Québec', group: 'regions' }, { id: 11, label: 'à Montréal', group: 'regions' }, { id: 58, label: 'à Laval', group: 'regions' }],
        inFilters: true,
        menu: [11, 58, 3]
      },
      tags: {
        inFilters: false,
        menuOrder: 'label'
      },
      types: {
        initialData: [{ id: 22, label: 'Arts et spectacles', tag: 'Type', group: 'types', slug: 'arts' }, { id: 13, label: 'Conférences et ateliers', tag: 'Type', group: 'types', slug: 'conferences' }, { id: 38, label: 'Célébration et commémoration', tag: 'Type', group: 'types', slug: 'celebration' }, { id: 4, label: 'Solidarité et vie collective', tag: 'Type', group: 'types', slug: 'solidarity' }, { id: 33, label: 'Sports et loisirs', tag: 'Type', group: 'types', slug: 'sports' }, { id: 1, label: 'Vente et promotion', tag: 'Type', group: 'types', slug: 'promotion' }],
        inFilters: true,
        menuOrder: 'label',
        treeView: true,
        menu: [22, 13, 38, 4, 33, 1]
      },
      venues: {
        inFilters: false,
        limit: 5
      }
    },
    filtersEntitiesOrder: 'audiences'.split(' '),
    show: {
      mapToggle: false,
      recurrencesButton: false,
      entityFilters: true,
      disclosableEntities: false
    },
    showcases: {
      featured: { id: [5798, 5769, 5207, 5321, 5726, 5936] },
      arts: { types: [22] },
      enfants: { audiences: [22, 21] },
      conferences: { types: [13] },
      all: { all: true }
    },
    map: {
      centerLat: 45.562371,
      centerLng: -73.600579,
      initialZoom: 15
    },
    externalScripts: []
  }
}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 39
// module chunks = 0